const cremeShop = '6298'; // 크렘므
const feminikShop = '1047'; // 페미니크
const LuluSeoulShop = '7107'; // 루루서울
const LarumShop = '3847';
const defaultTopDescriptionKeyList = ['exchange_info', 'payment_info', 'shipping_info'];
const defaultBottomDescriptionKeyList = ['service_info', 'simple_description'];

type keyListType = {
  top_description_key_list: string[];
  bottom_description_key_list: string[];
};

const extraInfo: Record<string, keyListType> = {
  [feminikShop]: {
    top_description_key_list: ['simple_description'],
    bottom_description_key_list: [],
  },
  [LarumShop]: {
    top_description_key_list: ['payment_info', 'exchange_info'],
    bottom_description_key_list: [],
  },
  [LuluSeoulShop]: {
    top_description_key_list: ['simple_description'],
    bottom_description_key_list: [],
  },
  [cremeShop]: {
    top_description_key_list: ['exchange_info', 'payment_info'],
    bottom_description_key_list: ['service_info', 'simple_description', 'shipping_info'],
  },
};

export const useExtraField = (shopId: string) => {
  if (extraInfo[shopId]) {
    return extraInfo[shopId];
  }

  return {
    top_description_key_list: defaultTopDescriptionKeyList,
    bottom_description_key_list: defaultBottomDescriptionKeyList,
  };
};
